import React from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import useTheme from "../../hooks/useTheme";

const bioVariants = {
	initial: {
		opacity: 0,
		x: -100,
	},
	animate: {
		opacity: 1,
		x: 0,
	},
	exit: {
		opacity: 0,
		x: -100,
	},
	transition: {
		duration: 1,
		delay: 0.5,
	},
};

const darkLinkSpanVariants = {
	hover: {
		scale: 1.3,
		backgroundColor: "rgb(0,0,0)",
	},
	transition: {
		duration: 0.3,
	},
};

const lightLinkSpanVariants = {
	hover: {
		scale: 1.3,
		backgroundColor: "rgb(255,255,255,0.5)",
	},
	transition: {
		duration: 0.3,
	},
};

const AboutBio = () => {
	const { theme } = useTheme();

	return (
		<>
			<motion.div
				variants={bioVariants}
				{...bioVariants}
				className="flex flex-col justify-around gap-2 p-5 max-w-3xl min-h-96">
				<h1 className="text-3xl md:text-5xl text-center">
					About <span className="text-green-800">Me</span>
				</h1>
				<div className="flex flex-col justify-evenly min-h-64">
					<p className="text-lg md:text-xl my-2">
						Hello! I am{" "}
						<span className="text-green-800 font-bold">
							Ivanvielle B. Dupaya
						</span>{" "}
						from{" "}
						<span className="text-green-800 font-semibold">
							Quezon City, Philippines
						</span>
						.
					</p>
					<p className="text-lg md:text-xl my-2">
						I graduated at{" "}
						<motion.span
							variants={
								theme === "dark" ? darkLinkSpanVariants : lightLinkSpanVariants
							}
							whileHover="hover"
							transition="transition"
							className="text-green-800 text-bold visited:text-green-800 font-bold inline-block">
							<Link
								to="https://feudiliman.edu.ph/"
								target="_blank">
								Far Eastern University - Diliman
							</Link>
						</motion.span>{" "}
						with a degree in Bachelor of Science in Business Administration
						major in Financial Management.
					</p>
					<p className="text-lg md:text-xl my-2">
						I trained to be a web developer at{" "}
						<motion.span
							variants={
								theme === "dark" ? darkLinkSpanVariants : lightLinkSpanVariants
							}
							whileHover="hover"
							transition="transition"
							className="text-blue-800 font-bold inline-block">
							<Link
								to="https://zuitt.co"
								target="_blank">
								Zuitt Coding Bootcamp
							</Link>
						</motion.span>{" "}
						where I learned the fundamentals, up-to-date technologies, and best
						practices of web development.
					</p>
				</div>
				<span className="text-lg md:text-xl flex flex-col justify-between min-h-32 gap-2">
					Apart from coding, here are some of the activities I love to do:
					<ul className="flex flex-col gap-1 justify-center px-5">
						<motion.li
							variants={
								theme === "dark" ? darkLinkSpanVariants : lightLinkSpanVariants
							}
							whileHover="hover"
							transition="transition"
							className="cursor-pointer max-w-[200px] relative left-5">
							💻Playing games
						</motion.li>
						<motion.li
							variants={
								theme === "dark" ? darkLinkSpanVariants : lightLinkSpanVariants
							}
							whileHover="hover"
							transition="transition"
							className="cursor-pointer max-w-[200px] relative left-5">
							📖Reading
						</motion.li>
						<motion.li
							variants={
								theme === "dark" ? darkLinkSpanVariants : lightLinkSpanVariants
							}
							whileHover="hover"
							transition="transition"
							className="cursor-pointer max-w-[200px] relative left-5">
							📺Binge watching
						</motion.li>
					</ul>
				</span>
			</motion.div>
		</>
	);
};

export default AboutBio;
